import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, from, map } from 'rxjs';
import { getFirebaseBackend } from '../../authUtils';
import { User as AppUser } from 'src/app/store/Authentication/auth.models';

import {
  signOut,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  User as FirebaseUser
} from 'firebase/auth';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private userSubject = new BehaviorSubject<FirebaseUser | null>(null);
  public user$: Observable<FirebaseUser | null> = this.userSubject.asObservable();

  user: AppUser;

  constructor() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.userSubject.next(user);
    });
  }

  /**
   * Returns the current user (from your custom backend service)
   */
  public currentUser(): AppUser {
    return getFirebaseBackend().getAuthenticatedUser(); // adapt this to modular SDK if needed
  }

  /**
   * Performs login
   */
  login(email: string, password: string) {
    const auth = getAuth();
    return from(signInWithEmailAndPassword(auth, email, password)).pipe(
        map((credential) => credential.user)
        // DO NOT catchError here — let the component handle it
    );
  }


  /**
   * Performs registration
   */
  register(user: AppUser) {
    const auth = getAuth();
    return from(
      createUserWithEmailAndPassword(auth, user.email, user.password)
    ).pipe(
      map((credential) => credential.user)
    );
  }

  /**
   * Sends password reset email
   */
  resetPassword(email: string) {
    const auth = getAuth();
    return from(sendPasswordResetEmail(auth, email));
  }

  /**
   * Logs out the current user
   */
  logout(): Observable<void> {
    return from(
      signOut(getAuth()).then(() => {
        sessionStorage.clear();
        localStorage.clear();
      })
    );
  }
}
